import { fetchUpdateUser } from '@/services/noteGoApi/noteGoApiComponents';
import { UserOut } from '@/services/noteGoApi/noteGoApiSchemas';

export interface UpdateModelGuidanceParams {
  userId: string;
  token: string;
  modelGuidance: string | null;
}

export const updateModelGuidance = async ({
  userId,
  token,
  modelGuidance,
}: UpdateModelGuidanceParams): Promise<UserOut> => {
  return fetchUpdateUser({
    headers: { authorization: `Bearer ${token}` },
    pathParams: { userId },
    body: {
      model_guidance: modelGuidance,
    },
  });
};
